const Alert = ({ children, message, type, color, className = "", ...props }) => {
  const baseClasses = "px-4 py-3 rounded-md border";

  // Map type to color if color is not provided
  const getColor = () => {
    if (color) return color;
    
    switch (type) {
      case "success":
        return "green";
      case "error":
        return "red";
      case "warning":
        return "yellow";
      default:
        return "blue";
    }
  };

  const colors = {
    blue: "bg-blue-50 border-blue-200 text-blue-800",
    green: "bg-green-50 border-green-200 text-green-800",
    yellow: "bg-yellow-50 border-yellow-200 text-yellow-800",
    red: "bg-red-50 border-red-200 text-red-800",
  };

  const selectedColor = getColor();
  const classes = `${baseClasses} ${colors[selectedColor]} ${className}`;

  // Use message prop if provided, otherwise use children
  const content = message || children;

  return (
    <div className={classes} {...props}>
      {content}
    </div>
  );
};

export default Alert;
